import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataStorageService} from 'shared/services/data-storage.service'; // NOSONAR
import {DownloadService} from 'shared/services/download.service'; // NOSONAR
import {TranslateService} from '@ngx-translate/core';
import {TEMOST_CONST} from 'shared/EnumsConstants/global-enum';
import {DataService} from 'shared/services/data.service';

@Component({
  selector: 'app-pending-changes-dialog',
  templateUrl: './pending-changes-dialog.component.html',
  styleUrl: './pending-changes-dialog.component.scss',
  standalone: false
})
export class PendingChangesDialogComponent {
  isReplace: boolean;
  constructor(
    private readonly download: DownloadService,
    private readonly translate: TranslateService,
    private readonly storage: DataStorageService,
    private readonly dataService: DataService,
    private readonly dialogRef: MatDialogRef<PendingChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isReplace = !data;
  }

  public onConfirm(): void {
    this.dialogRef.close(true);
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }

  async exportDataSheet() {
    const isModule2 = await this.storage.getIsForModule2();
    const module = isModule2 ? 'M2' : 'M1';
    const sender = (await this.storage.getIsForModule2())
      ? TEMOST_CONST.Sender.Module2
      : TEMOST_CONST.Sender.Module1;

    this.dataService.getInputData().then(inputdata => {
      this.download.exportExcelAnalyseData(
        inputdata,
        this.translate.currentLang,
        sender,
        module
      );
    });
  }
}
